import { I18n } from '@calendly/i18n'
import { SimplePopup } from '@calendly/ui/components/popup'
import { BodyText } from '@calendly/ui/components/typography'

export const RemoveConfirmationModal = ({ isOpen, onClose, onConfirm, title, text }) => (
  <SimplePopup
    isDestructive
    isOpen={isOpen}
    onClose={onClose}
    onConfirm={onConfirm}
    title={title}
    cancelLabel={I18n.t('publisher.event_types.edit_hosts_modal.remove_confirmation_modal.cancel')}
    confirmLabel={I18n.t('publisher.event_types.edit_hosts_modal.remove_confirmation_modal.confirm')}
  >
    {text && <BodyText>{text}</BodyText>}
  </SimplePopup>
)
